// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconCalendarAdd = createRemixIcon('IconCalendarAdd', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 2.25H16V0h2.5v2.25h4V12H20V8.5H2.5v11.75H12v2.5H0V2.25h4V0h2.5zM17.75 14v3.75H14v2.5h3.75V24h2.5v-3.75H24v-2.5h-3.75V14z\" clip-rule=\"evenodd\"/>");
